import axios from "axios";
import { baseUrl } from "../../App";

export const isPlayerHasFreePlayData = async (msisdn) => {
  if(!msisdn) return false;
  const res = await axios.get(`${baseUrl}/money/playerFreeQuizData/?msisdn=${msisdn}`);
  let dataArray = Array.isArray(res.data) ? res.data : [];
  return dataArray.length > 0;
}